import Navbar from "./Navbar/Navbar"

export default {
  Navbar
};
